/**
 * uiStore — OutpostForge frontend (CES standard, Zustand)
 * Cross-page UI state. Racks are COLLAPSED by default (large sites have
 * many racks), so the store tracks the expanded ones, keyed per Outpost so
 * the inventory keeps its layout when navigating away and back.
 */

import { create } from 'zustand';

interface UiState {
  /** outpostId → expanded rackIds (everything else renders collapsed). */
  expandedRacks: Record<string, string[]>;
  toggleRack: (outpostId: string, rackId: string) => void;
  setRacksExpanded: (outpostId: string, rackIds: string[]) => void;
  isRackExpanded: (outpostId: string, rackId: string) => boolean;
}

export const useUiStore = create<UiState>((set, get) => ({
  expandedRacks: {},

  toggleRack: (outpostId, rackId) =>
    set((state) => {
      const current = state.expandedRacks[outpostId] ?? [];
      const next = current.includes(rackId)
        ? current.filter((id) => id !== rackId)
        : [...current, rackId];
      return { expandedRacks: { ...state.expandedRacks, [outpostId]: next } };
    }),

  setRacksExpanded: (outpostId, rackIds) =>
    set((state) => ({
      expandedRacks: { ...state.expandedRacks, [outpostId]: rackIds },
    })),

  isRackExpanded: (outpostId, rackId) =>
    (get().expandedRacks[outpostId] ?? []).includes(rackId),
}));
